import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import {
  Params,
  WebhookSubscriptionAddPayload,
  WebhookSubscriptionUpdateData
} from 'types';

export const getWebhookSubscriptions = async (params: Params) => {
  const urlBuilder = createUrlBuilder(`/webhooks/subscriptions`).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const addNewWebhookSubscriptions = async (
  payload: WebhookSubscriptionAddPayload
) => {
  const urlBuilder = await createUrlBuilder(
    `/webhooks/subscriptions`
  ).toString();

  return await postRequest(AppService, urlBuilder, payload);
};

export const getWebhookSubscriptionById = async (subscriptionId: number) => {
  const urlBuilder = await createUrlBuilder(
    `/webhooks/subscriptions/${subscriptionId}`
  ).toString();

  return await getRequest(AppService, urlBuilder);
};

export const updatedWebhookSubscription = async (
  subscriptionId: number,
  payload: WebhookSubscriptionUpdateData
) => {
  const urlBuilder = await createUrlBuilder(
    `/webhooks/subscriptions/${subscriptionId}`
  ).toString();

  return await patchRequest(AppService, urlBuilder, payload);
};

export const deleteWebhookSubscription = async (subscriptionId: number) => {
  const urlBuilder = await createUrlBuilder(
    `/webhooks/subscriptions/${subscriptionId}`
  ).toString();

  return await deleteRequest(AppService, urlBuilder);
};

export const getWebhookNotificationHistory = async (params: Params) => {
  const urlBuilder = createUrlBuilder(`/webhooks/notifications`).toString();
  return await getRequest(AppService, urlBuilder, params);
};

export const getWebhookNotificationDetails = async (
  subscriptionId: number,
  notificationId: number
) => {
  const urlBuilder = createUrlBuilder(
    `/webhooks/subscriptions/${subscriptionId}/notifications/${notificationId}`
  ).toString();
  return await getRequest(AppService, urlBuilder);
};

export const redeliverWebhookNotification = async (payload: any) => {
  const redeliverActions = [];
  for (const load in payload) {
    const notificationId = payload[load].notificationId;
    const subscriptionId = payload[load].subscriptionId;
    const urlBuilder = createUrlBuilder(
      `/webhooks/subscriptions/${subscriptionId}/notifications/${notificationId}/redeliver`
    ).toString();
    redeliverActions.push(postRequest(AppService, urlBuilder, {}));
  }
  return await Promise.all(redeliverActions);
};
